export function getIn(target: any, path: PropertyKey[]) {
  for (const key of path) {
    if (
      target === undefined ||
      target === null ||
      typeof target !== 'object' ||
      !(key in target)
    ) {
      return
    }
    target = target[key]
  }
  return target
}
